import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Generator } from "../../../../components/Generator";
import { Grid } from "../../../../components/Grid";
import { selectUserData } from "../../../../components/appData.slice";
import { FormType } from "../../../../components/enums";
//import { useShouldRedirectToHomepage } from "../../../../hooks";
import { Url } from "../../../../router/enums";
//import { selectIsFormValidated } from "../../../../store/HOC/genericUI.selectors";
import { GenericPreload } from "../../../GenericPreload";
import { GenericSummary, SummarySection } from "../../../GenericSummary";
import {
  selectUIData,
  selectSummaryData as selectDamagesSummaryData,
} from "../Damages/damages.selectors";
import { selectSummaryData as selectIncidentSummaryData } from "../Incident/incident.selectors";
import { selectSummaryData as selectOwnerSummaryData } from "../Owner/owner.selectors";
import { selectSummaryData as selectPerpetratorSummaryData } from "../Perpetrator/perpetrator.selectors";

import { form } from "./form";

export const Summary = (): JSX.Element => {
  //JIRA LPPLWEBMOB-749
  const userData = useSelector(selectUserData);
  const { login, name, surname } = userData;
  const history = useHistory();
  const referrer = document.referrer;
  const isDirectEntry =
    history.action === "PUSH" && !referrer.includes(window.location.origin);

  if (!isDirectEntry && !login) {
    history.replace(Url.WELCOME);
  }
  //useShouldRedirectToHomepage(selectIsFormValidated(selectUIData));
  const perpetratorStoreData = useSelector(selectPerpetratorSummaryData);
  const incidentStoreData = useSelector(selectIncidentSummaryData);
  const ownerStoreData = useSelector(selectOwnerSummaryData);
  const damagesStoreData = useSelector(selectDamagesSummaryData);

  return (
    <GenericSummary
      currentRoute={Url.OC_PROPERTY_SUMMARY}
      formType={FormType.OC_PROPERTY}
    >
      <SummarySection data={perpetratorStoreData} title="Sprawca" />
      <SummarySection
        data={incidentStoreData.circumstances}
        title="Zdarzenie"
      />
      <SummarySection
        data={incidentStoreData.otherPersons}
        title="Inni uczestnicy zdarzenia"
      />
      <SummarySection data={ownerStoreData.owner} title="Dane właściciela" />
      <SummarySection
        data={ownerStoreData.contactPerson}
        title="Osoba kontaktowa"
      />
      <SummarySection
        data={damagesStoreData.damages}
        title="Uszkodzenia mienia"
      />
      <Helmet>
        <script
          src="../../../DamageRegistrationForm/LPPL_Scripts/ShowSubmitButton.js"
          type="text/javascript"
        />
      </Helmet>
      <Generator
        form={form}
        render={(generatedForm) => (
          <Grid item xs={12}>
            {generatedForm}
          </Grid>
        )}
      />
      <GenericPreload
        form={FormType.OC_PROPERTY}
        redirection={Url.OC_PROPERTY_SENDING}
      />
    </GenericSummary>
  );
};
